import { useContext } from 'react';
import { DUIContext } from './DUIContext';

export function useDUIContext() {
  return useContext(DUIContext);
}
